import { FEATURED_VALUE_THRESHOLD } from './featuredConfig';

export function isFeaturedValue(value) {
  return Number(value) >= FEATURED_VALUE_THRESHOLD;
}
